export const FEATURE_KEYS = {
  ADD_TO_CART: "add_to_cart",
  DEVICE_MANAGEMENT: "device_management",
  IVR: "ivr",
  IS_CUSTOMER_DETAILS_UPDATION_ALLOWED: "is_customer_details_updation_allowed",
  TOGGLE_CUSTOMER_LOGIN: "toggle_customer_login",
  SUBSCRIPTION_GRACE_PERIOD: "subscription_settings",
  KRA_FLOW: "kra_kyc",
  KRA_CVL_CREDS: "kra_cvl_creds",
  CUSTOM_TNC: "custom_t_c",
  CUSTOM_TNC_LABEL: "custom_t_c_label",
  KYC_TYPE: "kyc_type",
};
